import { render } from "./PhotoFun.vue?vue&type=template&id=0fd88842"
import script from "./PhotoFun.vue?vue&type=script&lang=js"
export * from "./PhotoFun.vue?vue&type=script&lang=js"

import "./PhotoFun.vue?vue&type=style&index=0&id=0fd88842&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__